import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { getCookie } from "../constants/cookie";

const useIFrameView = () => {
    const location = useLocation();

    return useMemo(() => {
        const params = new URLSearchParams(location.search);
        const iFrameViewQueryParam = params.get("iFrameView");
        if (iFrameViewQueryParam !== null) {
            return iFrameViewQueryParam === "true";
        }
        if (typeof document !== "undefined") {
            return getCookie("iFrameView") === "true";
        }
        return false;
        // eslint-disable-next-line
    }, [location.search]);
};

export default useIFrameView;
